import React from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash'
import PropTypes from 'prop-types'
import { getJson } from 'session';
// import moment from 'moment';

import * as actions from '../../actions'

import { InputTemplate } from "../../../../common/components/inputComponents";


const ViewUpdateOfficialReceipt = ({ formData, setFormData, validateForm, }) => {

  const handleOnChange = e => {
    setFormData(({
      ...formData,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <>
      <div className="full-group-v2 mb-3">
        <h2 className="h2 header-title">Update OR</h2>
        <div className="form-row">
          <InputTemplate
            title="OR Number"
            htmlFor="or_no"
            labelClassName="pl-0"
            containerClassName="col-12"
            formValidatorMsg={validateForm.renderMessage("or_no")}
            placeholder=""
            className="full-input-v2 text-uppercase"
            id="or_no"
            name="or_no"
            type="text"
            autoComplete="none"
            onChange={handleOnChange}
            value={_.get(formData, 'or_no')?.toUpperCase() || ''}
          />
        </div>
      </div>
    </>
  )
}

ViewUpdateOfficialReceipt.defaultProps = {}

ViewUpdateOfficialReceipt.propTypes = {
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  validateForm: PropTypes.instanceOf(Object).isRequired,
}

const mapStateToProps = () => ({
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, {... actions})]);

export default enhance(ViewUpdateOfficialReceipt);